import { render, staticRenderFns } from "./PrestacaoContasMensalForm.vue?vue&type=template&id=490f0286&"
import script from "./PrestacaoContasMensalForm.vue?vue&type=script&lang=js&"
export * from "./PrestacaoContasMensalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports